import createIcon from '../../createIcon';

/**
 * @component @name SkipNext
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAxOEwxNC41IDEyTDYgNlYxOFpNMTYgNlYxOEgxOFY2SDE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SkipNext = createIcon('SkipNext', [
  ['path', { d: 'M6 18L14.5 12L6 6V18ZM16 6V18H18V6H16Z', key: 'p32v4p' }],
]);

export default SkipNext;
